import authService from '../../components/api-authorization/AuthorizeService';
import { ICaseBookDetails, ICasebookSearchResults, IImportCase } from '../../types/types';

const casebookBaseURL = localStorage.getItem("casebookApiBaseURL");

export const searchCases = async (criteria: string): Promise<ICasebookSearchResults> => {
	

	return fetch(`api/case/searchCasebook/${criteria}`, {
		headers: {
			'Content-Type': 'application/json'			
		}
	})
		.then((response) => response.json())
		.catch((error) => Promise.reject(error));
};

export const getCasebookCaseForImportById = async (casebookCaseDetailId: number): Promise<IImportCase> => {
	

	return fetch(`api/case/importCasebookCase/${casebookCaseDetailId}`, {
		headers: {
			'Content-Type': 'application/json',
			
		}
	})
		.then((response) => response.json())
		.catch((error) => Promise.reject(error));
};

export const getCasebookCaseById = async (casebookCaseDetailId: number): Promise<ICaseBookDetails> => {
	

	return fetch(`api/case/getCasebookCaseDetails/${casebookCaseDetailId}`, {
		headers: {
			'Content-Type': 'application/json',
			
		}
	})
		.then((response) => response.json())
		.catch((error) => Promise.reject(error));
};

